<template>
  <div
    class="rodo-info"
    :class="{ 'rodo-info--on-map': onMap, 'rodo-info--on-map-absolute': onMapAbsolute }"
  >
    <span>
      Administratorem Danych Osobowych przetwarzanych na stronie internetowej
      jest Grupa Żywiec S.A. ul. Browarna 88, 34-300 Żywiec, więcej informacji
      o ochronie Twojej prywatności znajdziesz:
      <a href="https://grupazywiec.pl/polityka-prywatnosci/">Polityka Prywatności</a>.
    </span>
  </div>
</template>

<script>
export default {
  props: {
    onMap: {
      type: Boolean,
      default: false
    },
    onMapAbsolute: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .rodo-info {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: z(hero) + 1;

    padding: 8px 10px;
    font-size: 13px;
    color: rgba(#fff, 0.75);

    a {
      @include reset-link;
      text-decoration: underline;
    }

    &--on-map {
      @include media-down(md) {
        position: relative;
        padding-top: 30px;
        padding-bottom: 30px;
      }

      @include media-up(md) {
        padding-left: 80px;
      }
    }

    &--on-map-absolute {
      @include media-down(md) {
        position: absolute;
        padding-top: 30px;
        padding-bottom: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RodoInfo.vue